import { render } from "./listItemComponent.vue?vue&type=template&id=13c3a9ca&ts=true"
import script from "./listItemComponent.vue?vue&type=script&lang=ts"
export * from "./listItemComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__